import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "ba650043-ff14-4321-a4e4-5bacb7721f4b",
  publicId: "20",
  name: "Facades: curtain walls",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
